import { escapeHtml } from '@carbonwebmail/domain';
/**
 * A document for the block builder to open.
 *
 * Here rather than in the browser because it is *email* markup, which is a
 * different thing from the application's own: nested tables with inline styles,
 * because that is what mail clients render. The repository's markup rule points
 * at this package for exactly that reason — building UI by concatenation is how
 * the predecessor reached 13,939 lines, and building an email document is not
 * that.
 *
 * It is also the only definition of the shape. The builder's empty canvas and
 * the conversion from prose were the same 600px wrapper written twice, which is
 * two places for the width every mail client clips at to drift.
 *
 * Pure, and exported on its own path, so the browser can use it without
 * dragging the html sanitiser and its parser into the bundle.
 */
/** Wider than this and the message is clipped by every client worth naming. */
const WIDTH = 600;
export function startingDesign(prose) {
    const written = prose
        .split(/\n\s*\n/)
        .map((block) => block.trim())
        .filter((block) => block !== '')
        .map((block) => paragraph(escapeHtml(block).replace(/\n/g, '<br>')))
        .join('');
    return [
        `<table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background-color:#f4f5f7">`,
        '<tr><td align="center" style="padding:24px">',
        `<table role="presentation" width="${WIDTH}" cellpadding="0" cellspacing="0" style="max-width:${WIDTH}px;background-color:#ffffff">`,
        '<tr><td style="padding:32px">',
        // An empty page gives somebody nothing to drag onto and no sense of how
        // wide a message is, so there is always something in the column.
        written === ''
            ? paragraph('Drag a block in from the left, or click here and start typing.')
            : written,
        '</td></tr></table>',
        '</td></tr></table>',
    ].join('');
}
function paragraph(inner) {
    return `<p style="margin:0 0 16px 0;font-size:15px;line-height:23px;color:#344054">${inner}</p>`;
}
//# sourceMappingURL=startingDesign.js.map